import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useTRPC } from '@/lib/trpc'

export function useProjects() {
  const trpc = useTRPC()
  return useQuery(trpc.projects.list.queryOptions())
}

export function useCreateProject() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  return useMutation(
    trpc.projects.create.mutationOptions({
      onSuccess: () => queryClient.invalidateQueries(trpc.projects.list.pathFilter())
    })
  )
}

export function useUpdateProject() {
  const trpc = useTRPC()
  const queryClient = useQueryClient()
  return useMutation(
    trpc.projects.update.mutationOptions({
      onSuccess: () => queryClient.invalidateQueries(trpc.projects.list.pathFilter())
    })
  )
}
